import { setToastsError } from '../redux/actions/common';
import { setFiftyDiscount, setNbpbkbn, setProhibitedItem, setShowTableLimitOver } from '../redux/actions/modal';
import { setMaintenance } from '../redux/actions/storage';
import { ErrorMessage } from '../services';

const apiErrorHandler = (dispatch, error, disconnectMessage) => {
    dispatch(setMaintenance(false));
    let errorMessage =
        error?.status === 500 || !error
            ? (disconnectMessage ?? '通信が失敗しました。しばらく時間をおいて実行してください。')
            : error.status === 401
              ? '認証エラー'
              : (error.body?.message ?? disconnectMessage ?? '通信が失敗しました。しばらく時間をおいて実行してください。');

    if (error.status === 400) {
        if (error.body.errors?.length > 0 && error.body.errors[0].errorType === 'OTHER') {
            errorMessage = error.body.errors[0].message;
        }
    }

    switch (error.status) {
        case 401:
            window.location.href = '/login';
            break;
        case 503:
            dispatch(setMaintenance(true));
            break;
        default:
            dispatch(setToastsError(errorMessage));
            break;
    }
};

export const checkError = (error, errorType, exceptions = []) => {
    return error.body?.errors?.some((item) => item.errorType === errorType) && !exceptions.some((item) => item === errorType);
};

export const getItems = (error, items, errorType) => {
    const indexes = error.body?.errors?.filter((item) => errorType === item.errorType).map((item) => item.recordIndex);

    const data = indexes.map((index) => items[index]);
    return data;
};

export const apiValidationErrorHandler = (dispatch, error, items, disconnectMessage, exceptions = []) => {
    // ステータスコードが503の場合、表示
    if (error.status === 503) {
        apiChangeRequestErrorHandler(dispatch, error, disconnectMessage);
    }

    // 下限値チェック:下限値を下回っています。
    if (checkError(error, ErrorMessage.errorType.UNDER_LOWER_LIMIT, exceptions)) {
        const limitOverItems = getItems(error, items, ErrorMessage.errorType.UNDER_LOWER_LIMIT);
        if (limitOverItems.length > 0) {
            dispatch(
                setShowTableLimitOver({
                    isShow: true,
                    items: limitOverItems,
                }),
            );
            return;
        }
    }
    // 禁止商品チェック:登録禁止商品があります。
    if (checkError(error, ErrorMessage.errorType.PROHIBITED_ITEM, exceptions)) {
        const prohibitedItems = getItems(error, items, ErrorMessage.errorType.PROHIBITED_ITEM);
        if (prohibitedItems.length > 0) {
            dispatch(
                setProhibitedItem({
                    isShow: true,
                    items: prohibitedItems,
                }),
            );
            return;
        }
    }
    // PB・留型商品チェック:PB・留型商品は登録できません。
    if (checkError(error, ErrorMessage.errorType.PBLE_ITEM, exceptions)) {
        const nbpbkbnItems = getItems(error, items, ErrorMessage.errorType.PBLE_ITEM);
        if (nbpbkbnItems.length > 0) {
            dispatch(
                setNbpbkbn({
                    isShow: true,
                    items: nbpbkbnItems,
                }),
            );
            return;
        }
    }
    // 50%乖離チェック
    if (checkError(error, ErrorMessage.errorType.FIFTY_DISCOUNT, exceptions)) {
        const fiftyDiscountItems = getItems(error, items, ErrorMessage.errorType.FIFTY_DISCOUNT);
        if (fiftyDiscountItems.length > 0) {
            dispatch(
                setFiftyDiscount({
                    isShow: true,
                    items: fiftyDiscountItems,
                }),
            );
            return;
        }
    }
    // エラーメッセージ表示
    if (checkError(error, ErrorMessage.errorType.OTHER, exceptions)) {
        apiChangeRequestErrorHandler(dispatch, error, disconnectMessage);
    }
};

export const getErrorItems = (responseData, requestData, errorType) => {
    let ret = [];

    const errorItems = responseData.filter((item) => item.errorType === errorType);
    if (errorItems.length) {
        ret = errorItems.map((item) => requestData[item.recordIndex]);
    }

    return ret;
};

export const apiChangeRequestErrorHandler = (dispatch, error, disconnectMessage) => {
    dispatch(setMaintenance(false));
    const errorMessages =
        error?.status === 500 || !error
            ? [disconnectMessage ?? '通信が失敗しました。しばらく時間をおいて実行してください。']
            : error.status === 401
              ? '認証エラー'
              : error.body?.errors?.map((item) => item.message).length > 0
                ? error.body?.errors?.map((item) => item.message)
                : [disconnectMessage ?? '通信が失敗しました。しばらく時間をおいて実行してください。'];

    switch (error.status) {
        case 401:
            window.location.href = '/login';
            break;
        case 503:
            dispatch(setMaintenance(true));
            break;
        default:
            errorMessages.map((message) => {
                dispatch(setToastsError(message));
            });
            break;
    }
};

export default apiErrorHandler;
